import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import Code from "@material-ui/icons/Code";
import Email from "@material-ui/icons/Email";
import Face from "@material-ui/icons/Face";
import Filter7 from "@material-ui/icons/Filter7Rounded";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Group from "@material-ui/icons/Group";
import InputAdornment from "@material-ui/core/InputAdornment";
import Lock from "@material-ui/icons/Lock";
import Modal from '@material-ui/core/Modal';
import PermIdentity from "@material-ui/icons/PermIdentity";
import Phone from "@material-ui/icons/Phone";
import queryString from "query-string";
import React, { Component } from "react";
import PropTypes from "prop-types";
import Timeline from "@material-ui/icons/Timeline";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { some, values } from "lodash";

import Alerts from "components/EnergyCompany/Alert/Alerts";
import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import { CNPJMask, CPFMask, getFromAtob, removeNonDigits, telefoneMask } from "services/utils";
import { cadastrarUsuario } from "reducers/user/actions";
import { enviarEmailCadastro } from "services/auth";
import { showAlert } from "reducers/alerts/actions";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

const styles = theme => ({
  ...registerPageStyle,
  criarContaBtnWrapper: {
    paddingLeft: "14px",
  },
  emailSent: {
    fontWeight: "bold",
    marginBottom: "15px",
  },
  modalPaper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    height: "80%",
    margin: "auto",
    overflowY: "scroll",
    padding: theme.spacing.unit * 4,
    paddingTop: 0,
    width: "80%",
  },
  root: {
    display: "flex",
  },
  termosWrapper: {
    padding: "10px 0",
  },
  titleActions: {
    color:  "#3C4858",
    display: "flex",
    fontSize: "2.6em",
    justifyContent: "center",
  },
});

class RegisterPage extends Component {
  constructor(props) {
    super(props);

    const queryStringParsed = queryString.parse(props.location.search);
    const [id, nome, sobrenome] = getFromAtob([queryStringParsed.id, queryStringParsed.nome, queryStringParsed.sobrenome]);
    this.foiConvidado = !!queryStringParsed.codigo;

    this.state = {
      cadastrando: false,
      cnpj: '',
      confirmacaoPendente: false,
      confirmacaoSenha: '',
      cpf: '',
      enviandoEmailCadastro: false,
      id,
      isModalOpened: false,
      nome,
      senha: '',
      sobrenome,
      telefone: '',
      termosDeUsoChecked: false,
    };
  }

  checkTermos = () => {
    this.setState({ termosDeUsoChecked: !this.state.termosDeUsoChecked });
  }

  onCadastrarUsuarioBtnClicked = () => {
    const { cnpj, confirmacaoSenha, cpf, id, nome, senha, sobrenome, telefone, termosDeUsoChecked } = this.state;
    const { history, location } = this.props;
    const { codigo } = queryString.parse(location.search);

    const info = {
      cnpj: removeNonDigits(cnpj),
      codigo,
      confirmacaoSenha,
      cpf: removeNonDigits(cpf),
      id,
      nome,
      senha,
      sobrenome,
      telefone: removeNonDigits(telefone),
      termosDeUsoChecked,
    };

    this.setState({ cadastrando: true });

    this.props.cadastrarUsuario(info)
      .then(data => {
        if (data.confirmacaoPendente) {
          this.setState({ confirmacaoPendente: true });
        } else {
          history.push("/dashboard");
        }
      })
      .catch(({ response }) => {
        this.setState({ cadastrando: false });
        this.props.showAlert({ message: values(response.data).join(" "), type: 'error' });
      });
  }

  reenviarEmailCadastro = () => {
    this.setState({ enviandoEmailCadastro: true });

    enviarEmailCadastro({ email: this.state.id })
      .then(({ response }) => {
        this.setState({ enviandoEmailCadastro: false });
      })
      .catch(() => {
        this.setState({ enviandoEmailCadastro: false });
        this.props.showAlert({ message: 'Não conseguimos reenviar o email, por favor tente após alguns instantes.', type: 'error' });
      });
  }

  shouldDisableSubmitButton() {
    let requiredKeys = ["confirmacaoSenha", "cpf", "id", "nome", "senha", "sobrenome", "telefone", "termosDeUsoChecked"];
    return some(requiredKeys, requiredKey => !!this.state[requiredKey] === false);
  }

  render() {
    const { classes } = this.props;
    const { cadastrando, cnpj, confirmacaoPendente, confirmacaoSenha, cpf, enviandoEmailCadastro, id, isModalOpened, nome, senha, sobrenome, telefone, termosDeUsoChecked } = this.state;

    return (
      <div className={classes.container}>
        <GridContainer alignContent="center" justify="center">
          <GridItem md={10} sm={12} xs={12}>
            <ECCard
              content={
                <GridContainer justify="center">
                  <GridItem md={5} sm={12} xs={12}>
                    {this.foiConvidado ? (
                      <InfoArea
                        description="Olá, seja bem-vindo. Você foi convidado para fazer parte de uma assinatura."
                        icon={Group}
                        iconColor="info"
                        title="Faça parte de um time"
                      />
                    ) : (
                      <InfoArea
                        description="Tenha acesso ilimitado as funcionalidades do sistema, só pague após 30 dias se satisfeito."
                        icon={Filter7}
                        iconColor="info"
                        title="Comece seu trial de 30 dias"
                      />
                    )}
                    <InfoArea
                      description="Verifique a atratividade de preços do Mercado Livre x Cativo"
                      icon={Code}
                      iconColor="rose"
                      title="Mercado Livre x Cativo"
                    />
                    <InfoArea
                      description="Acompanhe o consumo dos agentes mês a mês"
                      icon={Timeline}
                      iconColor="primary"
                      title="Acompanhamento de consumo"
                    />
                    <InfoArea
                      description="Analise os dados de maneira estratégica para a sua tomada de decisões"
                      icon={Check}
                      iconColor="info"
                      title="Tome melhores decisões"
                    />
                  </GridItem>
                  <GridItem md={5} sm={8} xs={12}>
                    <form className={classes.form}>
                      <CustomInput
                        formControlProps={{ className: classes.customFormControlClasses, fullWidth: true }}
                        inputProps={{
                          disabled: confirmacaoPendente,
                          onChange: e => this.setState({ nome: e.target.value }),
                          placeholder: "Nome*",
                          startAdornment: (
                            <InputAdornment className={classes.inputAdornment} position="start">
                              <Face className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          value: nome,
                        }}
                      />
                      <CustomInput
                        formControlProps={{ className: classes.customFormControlClasses, fullWidth: true }}
                        inputProps={{
                          disabled: confirmacaoPendente,
                          onChange: e => this.setState({ sobrenome: e.target.value }),
                          placeholder: "Sobrenome*",
                          startAdornment: (
                            <InputAdornment className={classes.inputAdornment} position="start">
                              <Face className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          value: sobrenome,
                        }}
                      />
                      <CustomInput
                        formControlProps={{ className: classes.customFormControlClasses, fullWidth: true }}
                        inputProps={{
                          disabled: this.foiConvidado || confirmacaoPendente,
                          onChange: e => this.setState({ id: e.target.value }),
                          placeholder: "Email*",
                          startAdornment: (
                            <InputAdornment className={classes.inputAdornment} position="start">
                              <Email className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          value: id,
                        }}
                      />
                      <CustomInput
                        formControlProps={{ className: classes.customFormControlClasses, fullWidth: true }}
                        inputProps={{
                          disabled: confirmacaoPendente,
                          onChange: ({ target }) => target.value.length < 16 && this.setState({ telefone: target.value }),
                          placeholder: "Telefone*",
                          startAdornment: (
                            <InputAdornment className={classes.inputAdornment} position="start">
                              <Phone className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          value: telefoneMask(telefone),
                        }}
                      />
                      <CustomInput
                        formControlProps={{ className: classes.customFormControlClasses, fullWidth: true }}
                        inputProps={{
                          disabled: confirmacaoPendente,
                          onChange: ({ target }) => target.value.length < 15 && this.setState({ cpf: target.value }),
                          placeholder: "CPF*",
                          startAdornment: (
                            <InputAdornment className={classes.inputAdornment} position="start">
                              <PermIdentity className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          value: CPFMask(cpf),
                        }}
                      />
                      <CustomInput
                        formControlProps={{ className: classes.customFormControlClasses, fullWidth: true }}
                        inputProps={{
                          disabled: confirmacaoPendente,
                          onChange: ({ target }) => target.value.length < 19 && this.setState({ cnpj: target.value }),
                          placeholder: "CNPJ",
                          startAdornment: (
                            <InputAdornment className={classes.inputAdornment} position="start">
                              <PermIdentity className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          value: CNPJMask(cnpj),
                        }}
                      />
                      <CustomInput
                        formControlProps={{ className: classes.customFormControlClasses, fullWidth: true }}
                        inputProps={{
                          autoComplete: "new-password",
                          disabled: confirmacaoPendente,
                          onChange: e => this.setState({ senha: e.target.value }),
                          placeholder: "Senha*",
                          startAdornment: (
                            <InputAdornment className={classes.inputAdornment} position="start">
                              <Lock className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          type: "password",
                          value: senha,
                        }}
                      />
                      <CustomInput
                        formControlProps={{ className: classes.customFormControlClasses, fullWidth: true }}
                        inputProps={{
                          autoComplete: "new-password",
                          disabled: confirmacaoPendente,
                          onChange: e => this.setState({ confirmacaoSenha: e.target.value }),
                          placeholder: "Confirmar Senha*",
                          startAdornment: (
                            <InputAdornment className={classes.inputAdornment} position="start">
                              <Lock className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          type: "password",
                          value: confirmacaoSenha,
                        }}
                      />
                      <div className={classes.termosWrapper}>
                        <FormControlLabel
                          classes={{ root: classes.checkboxLabelControl, label: classes.checkboxLabel }}
                          control={
                            <Checkbox
                              checked={termosDeUsoChecked}
                              checkedIcon={<Check className={classes.checkedIcon} />}
                              classes={{ checked: classes.checked }}
                              disabled={confirmacaoPendente}
                              icon={<Check className={classes.uncheckedIcon} />}
                              onClick={this.checkTermos}
                            />
                          }
                          label={
                            <span>
                              Eu aceito os{" "}
                              <a onClick={() => this.setState({ isModalOpened: true })}>termos e condições</a>.
                            </span>
                          }
                        />
                      </div>
                      <div className={classes.criarContaBtnWrapper}>
                        {confirmacaoPendente ? (
                          <div>
                            {enviandoEmailCadastro ? <BouncingLoader /> : (
                              <div>
                                <div className={classes.emailSent}>
                                  Enviamos um email para você confirmar o cadastro, ele pode levar alguns minutos para chegar.
                                </div>
                                <Button
                                  color="primary"
                                  onClick={this.reenviarEmailCadastro}
                                  round
                                >
                                  Não recebeu o email? Reenvie
                                </Button>
                              </div>
                            )}
                          </div>
                        ) : (
                          cadastrando ? <BouncingLoader /> : (
                            <Button
                              color="primary"
                              disabled={this.shouldDisableSubmitButton()}
                              onClick={this.onCadastrarUsuarioBtnClicked}
                              round
                            >
                              Criar conta
                            </Button>
                          )
                        )}
                      </div>
                    </form>
                  </GridItem>
                </GridContainer>
              }
              title="Crie sua conta"
              titleActionsClass={classes.titleActions}
            />
            <Modal
              aria-describedby="simple-modal-description"
              aria-labelledby="simple-modal-title"
              classes={{ root: classes.root }}
              onClose={() => this.setState({ isModalOpened: false })}
              open={isModalOpened}
            >
              <div className={classes.modalPaper}>
                <h2>Termos de uso</h2>
                <p>
                  <strong>
                    Última atualização: 18 de Agosto de 2018
                  </strong>
                </p>

                <ol>
                  <li>
                    Os presentes termos de uso (doravante denominados “termos de uso”) governam o acesso e utilização dos sites, plataformas, aplicativos e serviços oferecidos pela Energy Company, bem como qualquer outro serviço vinculado diretamente a ela de qualquer forma (todos são doravante designados como Energy Company, assim como todo o empreendimento Energy Company também é designado pelo termo Energy Company). Os presentes termos de uso estabelecem condições essenciais e necessárias para a utilização da Energy Company. A utilização de qualquer serviço da Energy Company implica imediata aceitação dos presentes termos de uso, bem como dos termos de uso específicos aplicáveis. Os presentes termos de uso, além de regularem contratualmente a relação entre as partes, devem ser entendidos também como licença de uso dos serviços, aplicativos e plataformas da Energy Company. A Energy Company é detentora de vários bens intelectuais. Para a utilização de qualquer forma dos seus serviços, é obrigatório aceitar os presentes termos de uso. Sua não aceitação ou infração constitui não apenas violação dos presentes termos de uso, como também violação da propriedade intelectual da Energy Company.
                  </li>
                  <li>
                    A versão válida e eficaz dos presentes termos de uso é aquela publicada atualmente pelo site. Esta versão governa todas as relações passadas e presentes entre os usuários do site, respeitados direitos adquiridos, atos jurídicos perfeitos e coisas julgadas. O usuário deverá sempre ler atentamente os presentes termos de uso, e não poderá escusar-se deles alegando ignorância sobre seus termos, inclusive quanto a eventuais modificações.
                  </li>
                  <li>
                    Vários serviços e conteúdos oferecidos pelo site são objeto de termos de uso específicos. Esses termos de uso podem substituir, complementar ou modificar os presentes termos de uso. No caso de conflito entre os presentes termos de uso e a política de uso específicas aplicáveis a outras plataformas ou serviços específicos, o especial deverá prevalecer sobre o geral. As condições especiais também deverão sempre ser lidas pelos usuários, nos termos do item (2) acima. Outros avisos e comunicados poderão estar presentes ao longo do site, regulando sua forma de utilização. Esses avisos deverão ser interpretados em harmonia com os presentes termos de uso.
                  </li>
                </ol>

                <p>
                  <strong>
                    A. Objeto dos Termos de Uso
                  </strong>
                </p>

                <ol>
                  <li>
                    Uma vez que os presentes termos de uso são aceitos, o usuário tem a sua disposição diversos serviços disponibilizados pela Energy Company (doravante designados serviços).
                  </li>

                  <li>
                    Os serviços oferecidos pela Energy Company são de caráter restrito apenas para usuários que possuam assinaturas válidas.
                  </li>
                </ol>

                <p>
                  <strong>
                    B. Registro dos Usuários e Veracidade das Informações
                  </strong>
                </p>

                <ol>
                  <li>
                    O acesso aos serviços da Energy Company pode não exigir o prévio registro ou inscrição dos usuários na plataforma. Entretanto, esse não registro não implica que esses usuários não tenham aceitado os presentes termos de uso. Outros serviços da Energy Company, para serem acessados, exigem que o usuário seja cadastrado de acordo com mecanismos específicos de cadastro.
                  </li>
                  <li>
                    Toda informação oferecida pelo usuário para utilizar os serviços da Energy Company deverá ser verdadeira. O usuário garante a autenticidade de todos os dados que informar através do preenchimento dos formulários disponibilizados ou através de mecanismos automatizados de registro ou login. É de exclusiva responsabilidade do usuário manter qualquer informação fornecida à Energy Company permanentemente atualizada de forma a sempre refletir os dados reais do usuário. O fornecimento de declarações falsas ou inexatas constitui violação dos presentes termos de uso, bem como revogação da licença de utilização da Energy Company. Em quaisquer casos, o usuário será sempre o único e exclusivo responsável pela sua conduta e por danos por ela causados no âmbito da Energy Company, quanto a ela e quanto a terceiros e parceiros.
                  </li>
                  <li>
                    Crianças e adolescentes devem obter a prévia autorização dos pais, tutores ou representantes legais como forma de acessarem os serviços da Energy Company, os quais serão considerados responsáveis por todos os atos praticados pelos menores. Os pais, tutores ou representantes legais serão plenamente responsáveis também no caso de acesso dos serviços da Energy Company por parte de menores, sem a devida obtenção de autorização prévia. Cabe a eles a integral responsabilidade pela fiscalização das atividades e conduta das respectivas crianças ou adolescentes sob sua tutela.
                  </li>
                  <li>
                    O usuário se compromete a utilizar os serviços da Energy Company de boa-fé e em conformidade como todos os preceitos legais, regulamentares e contratuais porventura aplicáveis, bem como com a ordem pública, as normas e padrões de conduta do mercado geralmente aceitas ou tidas como boas práticas.
                  </li>
                  <li>
                    O usuário não poderá de nenhuma forma empregar mecanismos técnicos que de qualquer forma subvertam a regular utilização dos serviços da Energy Company, sem a prévia consulta aos gestores da Energy Company. Esses mecanismos incluem a utilização de robôs (robots, ou bots), spiders, scripts, IP spoof, MAC Address spoof ou qualquer outra forma de acesso automatizado ao site que de alguma forma sirva para desvirtuar suas finalidades e propósitos. O emprego desses recursos sem autorização prévia implica violação dos presentes termos de uso e sujeita a parte infringente ao pagamento de danos emergentes e lucros cessantes, bem como de multa punitiva que se aplicará mesmo que não tenha sido produzido qualquer dano, a ser arbitrada pelo juízo que for responsável pelo julgamento da causa.
                  </li>
                </ol>

                <p>
                  <strong>
                    C. Marcas, Patentes, Nomes Comerciais e Outros
                  </strong>
                </p>
                <ol>
                  <li>
                    Todas as marcas, patentes, nomes comerciais e sinais distintivos de qualquer espécie presentes nos serviços da Energy Company, incluindo sua própria marca e designação, são pertencentes a seus respectivos titulares de direito. Para a utilização de quaisquer destas marcas, nomes e sinais, é necessário a obtenção da respectiva autorização dos seus titulares.
                  </li>
                </ol>

                <p>
                  <strong>
                    D. Suspensão de Serviço e Retirada de Usuários
                  </strong>
                </p>
                <ol>
                  <li>
                    A prestação dos serviços da Energy Company depende de informações públicas fornecidas por instituições independentes, desta forma a mesma poderá terminar, suspender ou interromper bilateralmente e a qualquer momento, com a necessidade de prévio aviso, a prestação total ou parcial do serviço, ou sua inteira transformação e modificação, sem prejuízo as partes envolvidas.
                  </li>
                  <li>
                    O conteúdo desta publicação foi produzido pela Energy Company com base em dados e informações de conhecimento público. É de responsabilidade exclusiva dos agentes e demais interessados a obtenção de outros dados e informações, a realização de análises, estudos e avaliações para fins de tomada de decisões, definição de estratégias de atuação, assunção de compromissos e obrigações e quaisquer outras finalidades, em qualquer tempo e sob qualquer condição.
                  </li>
                </ol>
                <div className={classes.right}>
                  <Button
                    color="primary"
                    onClick={() => this.setState({ isModalOpened: false, termosDeUsoChecked: true })}
                    round
                  >
                    Aceitar Termos
                  </Button>
                </div>
              </div>
            </Modal>
          </GridItem>
        </GridContainer>
        <Alerts />
      </div>
    );
  }
}

RegisterPage.propTypes = {
  cadastrarUsuario: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  showAlert: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  cadastrarUsuario,
  showAlert,
};

export { RegisterPage as RegisterPageComponent };
export default connect(null, mapDispatchToProps)(withStyles(styles)(RegisterPage));



// WEBPACK FOOTER //
// ./src/views/Pages/RegisterPage.jsx